import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { documentValidator } from '@utils/functions/validator-input';
import { IBaseFormBuilder } from '../../builders/base-builder.class';

@Injectable({
  providedIn: 'root',
})
export class OtpBuilder implements IBaseFormBuilder {
  private form!: FormGroup;

  constructor() {
    this.form = new FormGroup({});
  }

  public build(): void {
    this.addEmailOtp();
    this.addCodeOtp();
  }

  private addEmailOtp() {
    this.form.addControl(
      'emailOtp',
      new FormGroup({
        email: new FormControl(null, [Validators.required])
      })
    );
  }

  private addCodeOtp() {
    this.form.addControl(
      'codeOtp',
      new FormGroup({
        code: new FormControl(null, [Validators.required, Validators.minLength(6), documentValidator()
        ])
      })
    );
  }

  getResult(): FormGroup {
    return this.form;
  }
}

export const getEmailOtpFormInstance = ({ from: form }: { from: FormGroup }) => form.get('emailOtp') as FormGroup;

export const getCodeOtpFormInstance = ({ from: form }: { from: FormGroup }) => form.get('codeOtp') as FormGroup;
